/*
 * Copyright (c) GeoMobile GmbH, 2022
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { connect } from 'react-redux';
import { DashboardView } from './Dashboard.view';
var mapStateToProps = function (state, ownProps) {
    return __assign(__assign({}, ownProps), { isLoggedIn: state.authState.isLoggedIn, token: state.authState.token });
};
var mapDispatchToProps = function (dispatch, ownProps) {
    return __assign({}, ownProps);
};
export var DashboardContainer = connect(mapStateToProps, mapDispatchToProps)(DashboardView);
